export default function currency(value, currencyCode) {
    if ((!value || value === null) && value !== 0) {
        return '';
    }

    const policyCurrencyCode = window.app.getPolicyData('currency_code');

    if (
        typeof currencyCode === "undefined" &&
        typeof policyCurrencyCode !== "undefined" &&
        policyCurrencyCode !== null
    ) {
        currencyCode = policyCurrencyCode;
    }

    const currencySuffix = typeof currencyCode === "undefined" ? `` : ` ${currencyCode}`;

    return Number.parseFloat(value).toLocaleString('en-GB', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }) + currencySuffix;
}
